export const GoogleAnalytics4ID = {
    dk: 'G-DNDX9R05WH',
    se: 'G-DNDX9R05WH',
    no: 'G-DNDX9R05WH',
    da: 'G-DNDX9R05WH'
}